import React, { useState } from 'react'
import OrdersAcceptModal from './modal'
import PropTypes from 'prop-types'
import ButtonIcon from 'components/button-icon'
import ResendIcon from 'components/icons/icn-resend.icon'

const ButtonOrderAccept = ({ disabled, accept, title }) => {
  const [showAlert, setShowAlert] = useState(false)

  const handleAccept = () => {
    setShowAlert(false)
    accept()
  }

  return (
    <React.Fragment>
      <div className="btn-content" title={title}>
        <ButtonIcon          
          buttonIcon={<ResendIcon />}          
          buttonText={title}
          style={{ width: "160px" }}
          buttonType="default"
          disabled={disabled}
          onClick={() => setShowAlert(true)}
        />
      </div>
      <OrdersAcceptModal
        onClick={handleAccept}
        open={showAlert}
        close={() => setShowAlert(false)}
      />
    </React.Fragment >
  )
}

ButtonOrderAccept.propTypes = {
disabled: PropTypes.bool,
accept: PropTypes.func,
title: PropTypes.string
}

export default ButtonOrderAccept
